import { useEffect, useState } from "react";
import { Box, Button, Paper, Switch, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Station } from "../../types/api";
import { deleteStation, listStations, updateStation } from "../../api/station";
import { Navigate } from "react-router-dom";
import { Add, Delete, Edit, EditAttributes } from "@mui/icons-material";
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2";


export default function StationListPage() {
    const [stations, setStations] = useState<Station[]>([]);
    const navigate = useNavigate()
    const role = (localStorage.getItem("role") || "").toLowerCase()
    const isInspector = role === "inspector"


    const load = async () => {
        const data = await listStations();
        setStations(data);
    };

    useEffect(() => {
        load();
    }, []);

    const columns: GridColDef[] = [
        { field: "nameTh", headerName: "ชื่อ (ไทย)", flex: 1 },
        // { field: "nameEn", headerName: "ชื่อ (อังกฤษ)", flex: 1 },
        // { field: "nameZh", headerName: "ชื่อ (จีน)", flex: 1 },
        { field: "latitude", headerName: "Latitude", flex: 2 },
        { field: "longitude", headerName: "Longitude", flex: 2 },
        {
            field: "isDisabled",
            headerName: "สถานะ",
            width: 160,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" gap={1}>
                    <Switch
                        checked={!params.row.isDisabled}
                        disabled={isInspector}
                        onChange={() =>
                            handleToggle(params.row.id, params.row.isDisabled)
                        }
                        color="warning"
                    />
                    <Typography variant="body2">
                        {params.row.isDisabled ? "ปิด" : "เปิด"}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'actions',
            headerName: 'การจัดการ',
            sortable: false,
            filterable: false,
            width: 180,
            renderCell: (params) => (
                !isInspector && ( // 👈 Inspector จะไม่เห็น action buttons เลย
                    <Box display="flex" gap={1}>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => navigate(`/stations/edit/${params.row.id}`)}
                            startIcon={<Edit />}
                            color="warning"
                        >
                            แก้ไข
                        </Button>
                        {/* <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            startIcon={<Delete />}
                            onClick={() => handleDelete(params.row.id)}
                        >
                            ลบ
                        </Button> */}
                    </Box>
                )
            ),
        },
    ];

    const handleToggle = async (id: number, currentValue: boolean) => {
        try {
            await updateStation(id, { isDisabled: !currentValue });
            setStations((prev) =>
                prev.map((lm) =>
                    lm.id === id ? { ...lm, isDisabled: !currentValue } : lm
                )
            );
        } catch (err) {
            console.error("Toggle failed", err);
        }
    };

    const handleDelete = async (id: number) => {
        const result = await Swal.fire({
            title: "คุณแน่ใจหรือไม่?",
            text: "คุณกำลังจะลบ สถานี นี้",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "ลบ",
            cancelButtonText: "ยกเลิก",
        });

        if (result.isConfirmed) {
            try {
                await deleteStation(id);
                await Swal.fire("ลบเรียบร้อย ✅", "", "success");
                load();
            } catch (err: any) {
                Swal.fire("ลบไม่สำเร็จ ❌", err.message, "error");
            }
        }
    };

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">รายการสถานี</Typography>
                {/* <Button
                    variant="contained"
                    onClick={() => navigate('/stations/create')}
                    sx={{ backgroundColor: '#FEDC00', color: '#000' }}
                    startIcon={<Add />}
                    disabled={isInspector}
                >
                    เพิ่มข้อมูล
                </Button> */}
            </Box>

            <Paper sx={{ height: 500, width: '100%', p: 1 }}>
                <DataGrid
                    rows={stations}
                    columns={columns}
                    pageSizeOptions={[5, 10, 20]}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    disableRowSelectionOnClick
                    getRowId={(row) => row.id}
                    sx={{
                        border: 0,
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: '#FEDC00',
                            color: '#000',
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-row': {
                            backgroundColor: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#FFFDE7', // แถวคี่
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#FFF59D', // hover
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #eee',
                        },
                    }}
                />
            </Paper>
        </Box>
    );
}
